globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.ResizeTextAreaToFitContent = (function () {
  function ResizeTextAreaToFitContent($html) {
    this.$html = $html;
  }

  ResizeTextAreaToFitContent.init = function ($html) {
    $html.find('.text-area-fit-content').each(function () {
      new ResizeTextAreaToFitContent($(this)).init();
    })
  }

  ResizeTextAreaToFitContent.prototype = {
    init: function () {
      var _this = this;

      _this._resize();

      _this.$html.on('input', function (e) {
        _this._resize();
      });
    },
    _resize: function () {
      this.$html[0].style.height = 'auto';
      this.$html[0].style.height = (this.$html[0].scrollHeight) + 5 + 'px';
    }
  }

  return ResizeTextAreaToFitContent;

})();
